import React from "react";
import "flowbite";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import { AuthContextProvider } from "./contexts/AuthContext";
import { SidebarProvider } from "./contexts/SidebarContext";

//Erro
import Error404 from "./pages/Private/error/404";
import DisplayPage from "./pages/Private/error/DisplayPage";

//Protect Router
import RedirectRouteLogin from "./routes/RedirectRouteLogin";
import ProtectedRoute from "./routes/ProtectedRoute";
import Login from "./pages/Public/login/Login";

//Dashboard
import Dashboard from "./pages/Private/dashboard/Index";

//Vendas

/**
 * 2º @Versão
 */

///////////////////////////

import CadastrarConta from "./pages/Public/cadastro/Index";
import RecuperarSenha from "./pages/Public/recuperarsenha/Index";

import PreCadastro from "./pages/Private/pre_cadastro/Index";
import AnalisandoDocumento from "./pages/Private/analisando_documento/Index";

import PageSales from "./pages/Private/vendas/Index";

import PageClient from "./pages/Private/clientes/Index";
import PageSaldo from "./pages/Private/saldo/Index";
import PageSaque from "./pages/Private/saque/Index";
import PageApi from "./pages/Private/integracao/Index";
import PageTaxa from "./pages/Private/taxa/Index";
import PageChavePix from "./pages/Private/chavepix/Index";
import PageInfracao from "./pages/Private/infracoes/Index";

import AjustesGerais from "./pages/Private/ajustes_gerais/Index";

function App() {
  return (
    <>
      <div className="application">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Medusa Payments</title>
        </Helmet>
      </div>
      <BrowserRouter>
        <SidebarProvider>
          <AuthContextProvider>
            <Routes>
              <Route path="*" element={<Error404 />} />
              <Route path="/err404" element={<Error404 />} />
              <Route path="/errD" element={<DisplayPage />} />

              <Route element={<RedirectRouteLogin />}>
                <Route index element={<Login />} />
                <Route path="/register" element={<CadastrarConta />} />
                <Route path="/recover-password" element={<RecuperarSenha />} />
              </Route>

              <Route element={<ProtectedRoute />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/" element={<Dashboard />} />

                <Route path="/sales" element={<PageSales />} />
                <Route path="/client" element={<PageClient />} />

                <Route path="/finance/infractions" element={<PageInfracao />} />
                <Route path="/finance/balancehistory" element={<PageSaldo />} />
                <Route path="/finance/withdraw" element={<PageSaque />} />
                <Route path="/finance/keypix" element={<PageChavePix />} />

                <Route path="/config/api" element={<PageApi />} />
                <Route path="/config/tax" element={<PageTaxa />} />
                <Route path="/config/general" element={<AjustesGerais />} />

                <Route path="*" element={<Error404 />} />
                <Route path="/complet-registration" element={<PreCadastro />} />
                <Route path="/analyzing" element={<AnalisandoDocumento />} />
              </Route>
            </Routes>
          </AuthContextProvider>
        </SidebarProvider>
      </BrowserRouter>
    </>
  );
}

export default App;
